import { fromJS } from 'immutable';

import {
  LOAD_LEGAL_ENTITIES_SUCCESS,
  UPDATE_LEGAL_ENTITY_SUCCESS,
  DELETE_LEGAL_ENTITY_SUCCESS,
} from 'constants/ActionTypes';

const initialState = fromJS({
  dataset: [],
  pagination: {
    totalCount: null,
    pageCount: null,
    currentPage: null,
    perPage: null,
  },
});

const legalEntityTableReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_LEGAL_ENTITIES_SUCCESS:
      return state.merge(
        fromJS({
          dataset: action.entities.items.map((entity) => entity.entityId),
          pagination: {
            totalCount: action.entities._meta.totalCount,
            pageCount: action.entities._meta.pageCount,
            currentPage: action.entities._meta.currentPage,
            perPage: action.entities._meta.perPage,
          },
        }),
      );
    case UPDATE_LEGAL_ENTITY_SUCCESS:
      if (state.get('dataset').includes(action.entity.entityId)) {
        return state;
      }
      return state.set('dataset', state.get('dataset').unshift(action.entity.entityId));
    case DELETE_LEGAL_ENTITY_SUCCESS: {
      const index = state.get('dataset').findIndex((id) => id === action.entityId);
      return index !== -1 ? state.deleteIn(['dataset', index]) : state;
    }
    default:
      return state;
  }
};

export default legalEntityTableReducer;
